import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const getSupplierPortalData = createApi(`SupplierPortalDataSlice`, "POST");

const SupplierPortalDataSlice = createSlice({
  name: 'SupplierPortalDataSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getSupplierPortalData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getSupplierPortalData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getSupplierPortalData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default SupplierPortalDataSlice.reducer;
